import {CanActivate, Router} from '@angular/router';
import {AngularFireAuth} from 'angularfire2/auth';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private auth: AngularFireAuth,
        private router: Router
    ) {}

    /**
     * acivate a specefic route based on authentication
     * @returns {Observable<boolean>}
     */
    canActivate()  {
        return this.auth.authState
            .take(1)
            .map(authState => !!authState)
            .do(authenticated => {
                if (!authenticated) {
                    this.router.navigate(['/auth']);
                }
            });
    }

}




// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/services/auth.guard.ts